var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _path12, _rect, _rect2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse2, _ellipse3, _ellipse4, _path22, _path23, _path24, _path25, _path26, _path27, _polygon, _g, _polygon2, _path28, _path29, _path30, _path31, _path32, _path33, _g2, _path34, _polygon3, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g3, _circle, _path51, _path52, _text, _text2, _ellipse5, _circle2, _path53, _path54, _path55, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _ellipse6, _path56, _path57, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _circle9, _g4, _ellipse12, _circle10, _g5, _ellipse13, _circle11, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500.07 400.07",
    style: {
      enableBackground: "new 0 0 500.07 400.07"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{opacity:0.3;fill:url(#SVGID_2_);enable-background:new    ;}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{opacity:0.3;fill:url(#SVGID_4_);enable-background:new    ;}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{opacity:0.3;fill:url(#SVGID_9_);enable-background:new    ;}\n\t.st9{opacity:0.3;fill:#87ABB7;enable-background:new    ;}\n\t.st10{fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);}\n\t.st14{fill:url(#SVGID_14_);}\n\t.st15{fill:url(#SVGID_15_);}\n\t.st16{fill:#FFFFFF;}\n\t.st17{fill:url(#SVGID_16_);}\n\t.st18{fill:url(#SVGID_17_);}\n\t.st19{fill:url(#SVGID_18_);}\n\t.st20{fill:url(#SVGID_19_);}\n\t.st21{fill:url(#SVGID_20_);}\n\t.st22{fill:url(#SVGID_21_);}\n\t.st23{fill:url(#SVGID_22_);}\n\t.st24{fill:url(#SVGID_23_);}\n\t.st25{fill:url(#SVGID_24_);}\n\t.st26{fill:#87ABB7;}\n\t.st27{fill:url(#SVGID_25_);}\n\t.st28{fill:url(#SVGID_26_);}\n\t.st29{fill:url(#SVGID_27_);}\n\t.st30{fill:url(#SVGID_28_);}\n\t.st31{fill:#C98777;}\n\t.st32{fill:#F2A78A;}\n\t.st33{fill:url(#SVGID_29_);}\n\t.st34{fill:url(#SVGID_30_);}\n\t.st35{fill:url(#SVGID_31_);}\n\t.st36{fill:url(#SVGID_32_);}\n\t.st37{fill:url(#SVGID_33_);}\n\t.st38{fill:url(#SVGID_34_);}\n\t.st39{fill:url(#SVGID_35_);}\n\t.st40{fill:url(#SVGID_36_);}\n\t.st41{fill:#4167C4;}\n\t.st42{fill:url(#SVGID_37_);}\n\t.st43{fill:url(#SVGID_38_);}\n\t.st44{fill:url(#SVGID_39_);}\n\t.st45{fill:url(#SVGID_40_);}\n\t.st46{fill:url(#SVGID_41_);}\n\t.st47{fill:url(#SVGID_42_);}\n\t.st48{fill:url(#SVGID_43_);}\n\t.st49{fill:url(#SVGID_44_);}\n\t.st50{fill:url(#SVGID_45_);}\n\t.st51{fill:url(#SVGID_46_);}\n\t.st52{fill:#B3D3C5;}\n\t.st53{fill:url(#SVGID_47_);}\n\t.st54{fill:url(#SVGID_48_);}\n\t.st55{font-family:'LeagueSpartan-Bold';}\n\t.st56{font-size:12px;}\n\t.st57{font-size:3.12px;}\n\t.st58{fill:url(#SVGID_49_);}\n\t.st59{fill:url(#SVGID_50_);}\n\t.st60{opacity:0.7;fill:url(#SVGID_51_);enable-background:new    ;}\n\t.st61{opacity:0.7;fill:url(#SVGID_52_);enable-background:new    ;}\n\t.st62{opacity:0.7;fill:url(#SVGID_53_);enable-background:new    ;}\n\t.st63{opacity:0.7;fill:url(#SVGID_54_);enable-background:new    ;}\n\t.st64{opacity:0.7;fill:url(#SVGID_55_);enable-background:new    ;}\n\t.st65{opacity:0.7;fill:url(#SVGID_56_);enable-background:new    ;}\n\t.st66{fill:url(#SVGID_57_);}\n\t.st67{fill:url(#SVGID_58_);}\n\t.st68{opacity:0.7;fill:url(#SVGID_59_);enable-background:new    ;}\n\t.st69{opacity:0.7;fill:url(#SVGID_60_);enable-background:new    ;}\n\t.st70{opacity:0.7;fill:url(#SVGID_61_);enable-background:new    ;}\n\t.st71{opacity:0.7;fill:url(#SVGID_62_);enable-background:new    ;}\n\t.st72{fill:url(#SVGID_63_);}\n\t.st73{fill:url(#SVGID_64_);}\n\t.st74{fill:url(#SVGID_65_);}\n\t.st75{fill:url(#SVGID_66_);}\n\t.st76{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st77{fill:none;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st78{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st79{fill:url(#SVGID_67_);}\n\t.st80{fill:url(#SVGID_68_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.7087,
    y1: 1278.4453,
    x2: 545.934,
    y2: 1278.4453,
    gradientTransform: "matrix(0.9998 0.0192 -0.0192 0.9998 -0.4946 -979.0522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392.07,357.76c10.69-9.04,24.96-15.96,28.93-29.38c4.61-15.6-7.25-31.07-9.19-47.22 c-1.9-15.84,6.34-31.82,18.8-41.78c6.82-5.45,23.13-22.42,23.13-22.42c-12.32,2.08-24.3,6.65-33.74,14.73 c-11.14,9.54-18.23,24.49-15.99,38.99c2.29,14.78,13.67,28.63,9.91,43.12c-3.23,12.46-16.14,19.27-25.68,27.9 c-15.6,14.12-22.81,35-23.36,56.3h2.9C371.85,382.4,379.75,368.17,392.07,357.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.1646,
    y1: 1206.3683,
    x2: 546.3006,
    y2: 1206.3683,
    gradientTransform: "matrix(0.9998 0.0192 -0.0192 0.9998 -0.4946 -979.0522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.77,152.56c-17.9-20.5-36.38-41.39-60.34-54.31c-23.95-12.92-54.9-16.4-77.79-1.67 c-12.98,8.35-22.67,18.42-31.65,35.8c-8.49,16.42-8.59,35.71-5,53.84c5.51,27.82,27.73,48.91,49.56,67.01s45.46,36.49,55.84,62.87 c7.5,19.07,7.02,41.14-1.3,59.87c-0.21,0.48-0.45,0.94-0.67,1.42c3.32-4.59,6.11-9.55,8.24-14.8c7.07-17.47,6.83-37.77-0.66-55.07 c-10.36-23.93-32.65-40.11-53.28-56.06c-20.63-15.96-41.71-34.66-47.63-60.06c-3.86-16.56-4.36-34.29,2.93-49.65 c7.72-16.25,16.31-25.81,27.98-33.89c20.58-14.25,49.14-12,71.56-0.87c22.42,11.13,40.06,29.76,57.15,48.05 c11.8,12.63,25.55,26.18,42.7,26.9C351.46,177.59,339.35,164.68,328.77,152.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.1553,
    y1: 1125.8062,
    x2: 546.3079,
    y2: 1125.8062,
    gradientTransform: "matrix(0.9998 0.0192 -0.0192 0.9998 -0.4946 -979.0522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDC9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M452.06,155.43c0.56,0.15,1.12,0.3,1.68,0.47v-0.46C453.18,155.42,452.62,155.42,452.06,155.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.3685,
    y1: 1262.8525,
    x2: 523.8728,
    y2: 1262.8525,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#87ABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3D3C5"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M365.84,339.18c6.74-6.55,14.83-12.89,16.79-22.13c3.5-16.46-14.21-30.58-14.45-47.42 c-0.12-7.89,3.77-15.43,9.15-21.16c5.39-5.72,12.19-9.86,19.04-13.68c7.04-3.92,14.22-7.56,21.54-10.93 c8.92-4.11,18.02-7.8,27.28-11.06c7.8-2.75,16.82-3.57,21.75-11.2c2.06-3.18,3.22-6.29,2.84-10.85c-0.33-3.94-1.43-7.85-3.65-11.1 c-1.04-1.53-1.76-2.33-3.05-3.66c-1.19-1.24-3.01-2.49-4.54-3.28c-1.97-1.02-3.96-1.21-6.03-1.41c-2.22-0.21-4.47-0.23-6.7-0.22 c-4.56,0.02-9.12,0.4-13.62,1.12c-8.9,1.44-17.59,4.28-25.59,8.5c-13.46,7.11-24.68,18.3-37.48,26.56 c-12.79,8.26-28.33,13.67-43.11,10.13c-11.84-2.84-21.5-11.41-29.48-20.68c-7.97-9.29-14.84-19.6-23.91-27.8 c-9.06-8.19-21.09-14.19-33.12-12.4c-12.04,1.79-22.87,13.61-20.43,25.65c2.28,11.28,13.82,17.56,23.3,23.98 c20.4,13.82,35.77,34.81,43.72,58.28c11.15,32.92,7.77,69.43-2.88,102.52c-3.65,11.35-8.12,22.35-13.1,33.14h65.46 C338.69,377.16,349.31,355.23,365.84,339.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.3124,
    y1: 1154.8744,
    x2: 504.3089,
    y2: 1154.8744,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8295DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B79FE1"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M425.32,157.45c-20.4,6.5-36.49,26.31-57.91,26.04c-0.34,0-0.68-0.02-1.01-0.04c2.86,0.83,5.82,1.36,8.89,1.5 c23.26,1.07,41.47-19.87,63.89-26.18c4.2-1.18,8.54-1.78,12.89-1.83C443.31,154.67,433.96,154.7,425.32,157.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.9898,
    y1: 1090.918,
    x2: 540.9901,
    y2: 1193.9178,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M425.32,157.45c-20.4,6.5-36.49,26.31-57.91,26.04c-0.34,0-0.68-0.02-1.01-0.04c2.86,0.83,5.82,1.36,8.89,1.5 c23.26,1.07,41.47-19.87,63.89-26.18c4.2-1.18,8.54-1.78,12.89-1.83C443.31,154.67,433.96,154.7,425.32,157.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.3122,
    y1: 1373.4539,
    x2: 504.3087,
    y2: 1373.4539,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8295DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B79FE1"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M234.41,400.07h8.82c5.8-6.66,10.62-14.34,14.18-22.68C251.33,386.65,243.44,394.45,234.41,400.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.815,
    y1: 1337.613,
    x2: 460.1333,
    y2: 1436.8591,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234.41,400.07h8.82c5.8-6.66,10.62-14.34,14.18-22.68C251.33,386.65,243.44,394.45,234.41,400.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.3705,
    y1: 1207.3024,
    x2: 552.9535,
    y2: 1323.4976,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M453.74,217.1c6.3-1.74,6.09-1.74,6.65-2.05c3.46-1.89,1.68-0.97,5.19-2.94c3.44-1.93,7.29-3.05,10.64-5.14 c3.34-2.09,6.36-4.97,7.75-8.68c1.02-2.72,1.09-5.7,0.82-8.59c-0.77-8.04-4.25-15.8-9.75-21.68c-3.1-3.32-6.84-6.04-10.93-8 c-2.04-0.98-4.18-1.77-6.37-2.36c-1.07-0.29-2.21-0.42-3.26-0.76c-0.75-0.24-1.57,0.03-2.4,0.04c-4.35,0.06-8.27,0.4-12.47,1.59 c-22.41,6.36-40.96,26.78-64.23,25.69c-3.07-0.14-6.03-0.67-8.89-1.51c-17.15-0.73-30.9-14.36-42.7-27.06 c-17.09-18.4-34.73-37.14-57.15-48.34c-22.42-11.2-50.98-13.46-71.56,0.88c-11.67,8.13-20.26,17.75-27.98,34.09 c-7.29,15.45-6.79,33.29-2.93,49.95c5.92,25.55,27,44.37,47.63,60.42c20.63,16.05,42.92,32.32,53.28,56.4 c7.49,17.4,7.73,37.83,0.66,55.4c-2.13,5.28-4.92,10.28-8.24,14.89c-3.56,7.63-8.38,14.64-14.18,20.72h26.9 c4.98-10.75,9.45-21.72,13.1-33.03c10.66-32.98,14.04-69.38,2.89-102.18c-7.95-23.39-23.32-44.32-43.72-58.09 c-9.48-6.4-21.02-12.66-23.3-23.9c-2.44-12,8.39-23.78,20.43-25.56c12.03-1.78,24.06,4.21,33.12,12.36 c9.07,8.17,15.94,18.45,23.91,27.71c7.98,9.25,17.64,17.79,29.48,20.61c14.78,3.52,30.22-2.51,43.01-10.73 c12.8-8.23,24.12-18.75,37.58-25.84c7.76-4.08,15.72-7.66,24.35-9.13c4.32-0.74,8.76-1.11,13.14-1.19 c2.14-0.04,4.31,0.01,6.45,0.12c1.94,0.1,4.79,0.43,6.63,0.94c2.05,0.57,6.96,4.5,8.14,6.28c1.64,2.48,2.38,3.93,3.24,6.78 c0.63,2.1,1.18,3.93,1.2,6.92c0.02,3.66-0.62,6.29-2.82,9.23c-2.2,2.94-4.54,5.21-7.86,6.76c-1.51,0.71-3.87,1.52-5.44,1.99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M388.24,343.17c9.54-8.72,22.45-15.6,25.68-28.2c3.76-14.64-7.62-28.64-9.91-43.58 c-2.24-14.65,4.85-29.76,15.99-39.41c9.44-8.18,21.42-12.79,33.74-14.89v-6.98c-20.08,6.09-39.11,14.3-57.36,24.47 c-6.85,3.82-13.65,7.96-19.04,13.69c-5.38,5.73-9.27,13.28-9.15,21.18c0.24,16.86,17.95,31,14.45,47.48 c-1.96,9.25-10.05,15.59-16.79,22.15c-16.53,16.08-27.15,38.03-30.26,60.97h29.29C365.43,378.54,372.64,357.44,388.24,343.17z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 190.5312,
    cy: -453.1676,
    r: 18.5364,
    gradientTransform: "matrix(0 1.6592 -0.9712 0 -227.0575 -215.0608)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9B9BE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 213.06,
    cy: 101.07,
    rx: 18,
    ry: 30.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 592.6935,
    y1: 955.9531,
    x2: 563.615,
    y2: 965.2493,
    gradientTransform: "matrix(0.9525 0.3045 -0.3045 0.9525 -36.1784 -860.6974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#AD775A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#634723"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M241.79,233.38c-2.01-0.48-2.98-1.26-4.18-1.67c-1.3-0.45-1.48-0.56-3.08-0.45c-1.6,0.11-3.37,1.28-4.69,1.96 c-0.11,0.06-0.18,0.1-0.28,0.15c-0.75-0.26-1.31-0.43-1.31-0.43c-4.57-0.83-21.46-8.01-22.68-10.39c-1.23-2.38-3.52,0.5-2.76,3.73 c0.76,3.22,16.15,11.35,26.31,10.64c0.01,0,0.02,0,0.04,0v0.01c0.01-0.01,0.03-0.01,0.04-0.01c0.19-0.01,0.36-0.03,0.53-0.04 c1.46,0.17,4.27,2.06,4.85,2.14c0.73,0.1,4.71-0.89,4.57-1.28c-0.66-0.7-2-0.41-2.69-0.39c-0.68,0.01-1.06-0.66-1.06-0.66 c2.15-0.16,5.35-2.36,7.17-1.87C244.38,235.29,243.43,233.77,241.79,233.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.1347,
    y1: 1199.2024,
    x2: 199.127,
    y2: 1204.2694,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2D438F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C65A8"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M209.37,208.59c-3.96,0.6-5.75,6.23-6.5,11.69c-0.69,4.99,3.58,2.33,4.83,1.67 C208.95,221.28,209.37,208.59,209.37,208.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.0458,
    y1: 1108.5881,
    x2: 208.5158,
    y2: 1108.5881,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#926A61"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207.05,
    y: 119.87,
    className: "st13",
    width: 1.47,
    height: 7.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.6052,
    y1: 1108.5881,
    x2: 219.0752,
    y2: 1108.5881,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 217.61,
    y: 119.87,
    className: "st14",
    width: 1.47,
    height: 7.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.3989,
    y1: 1083.0382,
    x2: 231.7189,
    y2: 1083.0382,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#87ABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M231.72,94.65c0,5.61-2.48,10.64-6.4,14.07c-2.71,2.36-4.36,5.71-4.36,9.31v0.23 c0,1.31-1.06,2.37-2.37,2.37h-1.58c0.94,0,1.69-1.06,1.69-2.37v-0.23c0-3.6,1.18-6.94,3.12-9.31c2.8-3.42,4.57-8.45,4.57-14.07 c0-10.14-5.78-18.4-12.99-18.65C223.55,76.18,231.72,84.46,231.72,94.65z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M226.39,94.65c0,5.61-1.77,10.64-4.57,14.07c-1.94,2.36-3.12,5.71-3.12,9.31v0.23 c0,1.31-0.76,2.37-1.69,2.37h-1.58c0.56,0,1.01-1.06,1.01-2.37v-0.23c0-3.6,0.71-6.94,1.87-9.31c1.68-3.42,2.74-8.45,2.74-14.07 c0-10.13-3.46-18.37-7.77-18.65c0.04,0,0.08,0,0.12,0C220.61,76.25,226.39,84.5,226.39,94.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.0589,
    y1: 1083.0332,
    x2: 221.0589,
    y2: 1083.0332,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#87ABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M221.06,94.65c0,5.61-1.06,10.64-2.74,14.07c-1.16,2.36-1.87,5.71-1.87,9.31v0.23 c0,1.31-0.45,2.37-1.01,2.37h-1.58c0.19,0,0.34-1.06,0.34-2.37v-0.23c0-3.6,0.23-6.94,0.62-9.31c0.56-3.42,0.91-8.45,0.91-14.07 c0-10.3-1.19-18.66-2.67-18.66c0.08,0,0.15,0,0.23,0.01C217.6,76.27,221.06,84.52,221.06,94.65z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M215.72,94.65c0,5.61-0.36,10.64-0.91,14.07c-0.39,2.36-0.62,5.71-0.62,9.31v0.23 c0,1.31-0.15,2.37-0.34,2.37h-0.79h-0.79c-0.19,0-0.34-1.06-0.34-2.37v-0.23c0-3.6-0.24-6.94-0.62-9.31 c-0.56-3.42-0.92-8.45-0.92-14.07c0-10.3,1.2-18.66,2.67-18.66S215.72,84.34,215.72,94.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.0589,
    y1: 1083.0332,
    x2: 213.0589,
    y2: 1083.0332,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#87ABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M212.85,76c0.07-0.01,0.14-0.01,0.21-0.01c-1.47,0-2.67,8.35-2.67,18.66c0,5.61,0.36,10.64,0.92,14.07 c0.39,2.36,0.62,5.71,0.62,9.31v0.23c0,1.31,0.15,2.37,0.34,2.37h-1.58c-0.56,0-1.02-1.06-1.02-2.37v-0.23 c0-3.6-0.71-6.94-1.87-9.31c-1.68-3.42-2.74-8.45-2.74-14.07C205.07,84.5,208.53,76.25,212.85,76z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M212.71,76c0.05,0,0.09,0,0.14,0c-4.32,0.25-7.79,8.51-7.79,18.65c0,5.61,1.06,10.64,2.74,14.07 c1.17,2.36,1.87,5.71,1.87,9.31v0.23c0,1.31,0.46,2.37,1.02,2.37h-1.58c-0.94,0-1.69-1.06-1.69-2.37v-0.23 c0-3.6-1.18-6.94-3.12-9.31c-2.8-3.42-4.57-8.45-4.57-14.07C199.73,84.5,205.52,76.25,212.71,76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.3889,
    y1: 1083.0282,
    x2: 212.6989,
    y2: 1083.0282,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#87ABB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M209.11,120.62h-1.58c-1.31,0-2.37-1.06-2.37-2.37v-0.23c0-3.6-1.65-6.94-4.37-9.31 c-3.92-3.42-6.4-8.45-6.4-14.07c0-10.19,8.17-18.47,18.31-18.65c-7.2,0.25-12.98,8.51-12.98,18.65c0,5.61,1.77,10.64,4.57,14.07 c1.94,2.36,3.12,5.71,3.12,9.31v0.23C207.42,119.55,208.18,120.62,209.11,120.62z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.9542,
    y1: 1115.23,
    x2: 211.8917,
    y2: 1115.605,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A6666"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M221.06,126.81v3.58c0,3.61-2.68,6.6-6.16,7.08c-0.33,0.06-0.66,0.08-1,0.08h-1.68 c-3.95,0-7.15-3.21-7.15-7.16v-3.58c0-1.22,0.98-2.21,2.2-2.21h11.58C220.07,124.6,221.06,125.59,221.06,126.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.7289,
    y1: 1115.7582,
    x2: 221.0589,
    y2: 1115.7582,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M221.06,126.81v3.58c0,3.61-2.68,6.6-6.16,7.08c-3.48-0.47-6.17-3.47-6.17-7.08v-3.58 c0-1.22,0.99-2.21,2.21-2.21h7.91C220.07,124.6,221.06,125.59,221.06,126.81z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: -787.7394,
    cy: -599.9709,
    r: 6.6204,
    gradientTransform: "matrix(-2.4922 0 0 -1.9531 -1650.4651 -905.7446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6A391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 312.74,
    cy: 266.06,
    rx: 16.5,
    ry: 12.93
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: -823.8521,
    cy: -382.0585,
    r: 5.8734,
    gradientTransform: "matrix(-2.4922 0 0 -2.6292 -1650.4651 -831.1296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6A391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 402.74,
    cy: 173.38,
    rx: 14.64,
    ry: 15.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: -779.6501,
    cy: -638.2526,
    r: 18.5372,
    gradientTransform: "matrix(-2.4922 0 0 -1.7452 -1650.4651 -918.4697)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9B9BE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 292.58,
    cy: 195.41,
    rx: 46.2,
    ry: 32.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.3789,
    y1: 1165.4182,
    x2: 338.7789,
    y2: 1165.4182,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M330.78,216.76h-76.4c-4.42,0-8-3.58-8-8v-56.13c0-4.42,3.58-8,8-8h76.4c4.42,0,8,3.58,8,8v56.13 C338.78,213.18,335.2,216.76,330.78,216.76z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M325.99,179.32H298c-2.16,0-3.92-1.75-3.92-3.92v-18.5c0-2.16,1.75-3.92,3.92-3.92h27.99 c2.16,0,3.92,1.75,3.92,3.92v18.5C329.91,177.57,328.15,179.32,325.99,179.32z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M323.57,158.39c-3.21,2.11-4.66,6.38-8.13,8.02c-1.3,0.62-2.81,0.79-4.22,0.48 c-2.37-0.52-4.59-2.33-6.94-1.74c-1.93,0.49-3.07,2.4-4.17,4.06c-1.44,2.19-3.14,4.19-5.03,5.99v0.2c0,1.61,1.31,2.92,2.92,2.92 h27.99c1.61,0,2.92-1.31,2.92-2.92v-18.21C327.06,156.96,325.13,157.36,323.57,158.39z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.5189,
    y1: 1244.4182,
    x2: 327.9589,
    y2: 1244.4182,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M323.16,271.58h-20.84c-2.65,0-4.8-2.15-4.8-4.8v-14.17c0-2.65,2.15-4.8,4.8-4.8h20.84 c2.65,0,4.8,2.15,4.8,4.8v14.17C327.96,269.43,325.82,271.58,323.16,271.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.8497,
    y1: 1247.8097,
    x2: 327.7157,
    y2: 1247.8097,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB3C1"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M362.84,263.37c0.03-4.75-2.22-6.13-2.22-6.13c-6.59,0-13.52,5.08-22.73,5.33l-0.01-0.02 c-0.02,0.01-0.04,0.01-0.06,0.02c-0.4,0.01-0.81,0.01-1.22,0c-1.57-0.34-3.83-1.49-4.34-1.51c-0.73-0.02-4.59,1.4-4.41,1.77 c0.73,0.63,2.03,0.19,2.71,0.1s1.13,0.54,1.13,0.54c-2.12,0.39-5.06,2.93-6.92,2.64c-1.86-0.28-0.76,1.12,0.92,1.33 c2.05,0.26,3.1,0.93,4.34,1.21c1.34,0.3,1.53,0.4,3.11,0.11c1.44-0.26,2.92-1.41,4.11-2.23 C340.3,267.06,351.5,268.48,362.84,263.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.6161,
    y1: 1230.5363,
    x2: 351.2498,
    y2: 1230.5363,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB3C1"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M383.93,248.62c-5.67-3.36-14.22-2.53-22.27-7v-0.03c-0.02,0-0.04-0.01-0.06-0.01 c-0.35-0.2-0.7-0.4-1.05-0.62c-1.18-1.09-2.54-3.24-2.96-3.51c-0.62-0.39-4.66-1.14-4.69-0.72c0.31,0.91,1.66,1.2,2.28,1.47 c0.63,0.27,0.69,1.04,0.69,1.04c-2.02-0.74-5.85-0.06-7.3-1.26c-1.46-1.19-1.22,0.57,0.11,1.61c1.63,1.27,2.19,2.38,3.12,3.25 c1,0.94,1.12,1.12,2.62,1.68c1.37,0.51,3.23,0.28,4.67,0.18c2.35,2.01,11.26,8.95,23.63,10.32 C385.16,250.95,383.93,248.62,383.93,248.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.3289,
    y1: 1311.8182,
    x2: 425.5789,
    y2: 1311.8182,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB3C1"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "420.5,331.35 425.58,328.51 422.4,322.84 417.33,325.68  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M418.2,345.46c-0.74-1.63-1.49-2.65,0.2-7.1c1.04-2.74,0.37-7.17,1.02-8.15c0.55-0.84,0.71,1.22,2.08,0.04 c1.02-0.88-0.03-1.66,0.17-2.34c0.55-1.94,2.72-2.31,3.82-1.57c0.76,0.52,2.19,2.37,2.25,3.6s-4.08,6.09-4.24,6.33 C423.34,336.5,418.2,345.46,418.2,345.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M427.81,330.36c-0.03-1.46-2.15-2.39-3.39-1.21c-1.24,1.17-2.13,3.04-2.53,5.36 c-0.61,3.56-2.39,3.91-3.59,7.64c-1.11,3.46,0.66,5.02,2.29,4.32c1.63-0.69,4.76-2.76,5.76-7.35 C427.05,335.9,427.85,332.76,427.81,330.36z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.8389,
    y1: 1316.7231,
    x2: 387.7389,
    y2: 1316.7231,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB3C1"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "383.26,336.47 387.74,332.44 383.32,327.53 378.84,331.56  "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M382.57,352.5c-5.66-2.24-1.55-15.14-1.39-16.15c0.16-1.01,0.49-2.08,1.17-0.96c0.68,1.12,0.88,0.38,1.22-0.9 c0.39-1.44,1.07-2.51,2.1-2.96s1.9,0.22,3.6,2.49L382.57,352.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M384.57,336.01c0.88-1.48,3.19-3.45,4.69-1.98c1,0.98-0.62,4.58-0.95,5.62c-0.66,2.11,0.97,4.18-0.4,7.6 c-0.72,1.8-3.48,6.8-5.34,5.26c-2.28-1.87-1.65-8.11-0.28-11.19S383.84,337.25,384.57,336.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.5469,
    y1: 1282.1537,
    x2: 424.9473,
    y2: 1282.1537,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2D438F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C65A8"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M408.48,305.42c-4.46-6.68-5.99-28.21-12.31-34.04c-1.22-1.13-2.17-1.96-4.27-4.04 c-0.8-1.34-1.9-2.31-3.11-2.87c-2.57-2.23-4.8-3.9-4.8-3.9s-0.02,2.51-0.04,5.56c-4.09,3.27-5.61,13.62-5.61,13.62 c-10.85,12.52-14.56,23.18-14.79,29.06c-0.22,5.65,17.7,26.65,17.3,25.43c0.2-2.56,0.45-3.93,4.76-4.52 c1.71-0.05-10.87-18.34-11.18-20.77c-0.58-4.44,11.18-12.62,15.49-20.57c2.51,6.13,6.95,16.33,8.58,19.89 c1.68,3.67,20.23,22.85,20.19,20.7c-0.02-1.88,2.58-4.23,6.16-3.7C426.2,325.42,413.3,312.64,408.48,305.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -528.5025,
    y1: 1408.359,
    x2: -513.842,
    y2: 1408.359,
    gradientTransform: "matrix(-0.8955 0.4451 0.4451 0.8955 -721.2671 -797.1503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC5A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB3C1"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M364.97,232.64c-0.32-2.97-2.71-5.21-2-6.29c0.55-0.85,3.47-5.88,9.04-5.86c4.58,0.01,6.37,8.33,6.87,11.29 l0,0c0.76,3.28,2.74,4.42,2.74,4.42c1.36,1.83-0.73,3.93-1.59,4.62c-0.62,0.49-3.34,2.37-4.7,0.53l-2.18-3.01 c-1.13,1.09-3.23,1.48-4.28,0.51C367.12,237.25,365.32,235.89,364.97,232.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: -521.3668,
    y1: 1394.7208,
    x2: -525.0959,
    y2: 1410.0516,
    gradientTransform: "matrix(-0.8955 0.4451 0.4451 0.8955 -721.2671 -797.1503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#753F1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C3616"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M377.36,233.8c-0.78,0.5-4.06,0.25-4.59-1.73c-0.52-1.99-1.26-3-2.34-2.54c-0.45,0.19,0.8,1.81-0.23,1.8 c-0.88-0.01-1.8-0.18-1.9-0.53c-0.5-1.75-1.02-4.15-3.94-2.75c-1.53,0.73-2.31-1.36-2.76-2.93c0.39-2.19,1.86-3.13,3.87-4.92 c3.38-3.01,7.95-1.96,8.85-1.04c3.06,1,5.84,2.58,4.6,8.53c-0.58,2.79,0.37,3.62,0.12,4.74 C378.42,233.13,377.36,233.8,377.36,233.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.4914,
    y1: 1243.5206,
    x2: 398.8656,
    y2: 1243.5206,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2A783"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M393.15,259.81c1.01-9.98-0.79-14.73-1.54-18.9c-0.58-3.23-5.04-5.13-10.58-5.16c1.2,1.33-4.02,6.4-7.14,3.63 c-2.87,4.57-6.15,7.77-7.5,10.45c-1.4,2.78-4.66,4.47-7.03,6.53c-2.23,1.94,0.25,8.01,2.81,7.81c2.47-0.19,7.38-2.38,9.31-3.97 c0.22,0.62,3.07,5.49,3.25,6.09c1.92,6.54,2.36,10.25,3.87,13.19c1.52,2.94,15.12,3.93,19.38-1.74 C401.72,272.77,392.37,267.51,393.15,259.81z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 161.21,
    className: "st26",
    width: 9.64,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 164.07,
    className: "st16",
    width: 22.71,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 166.93,
    className: "st16",
    width: 22.71,
    height: 1.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 272.91,
    y: 176.28,
    className: "st26",
    width: 8.67,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 179.14,
    className: "st16",
    width: 22.71,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 182.01,
    className: "st16",
    width: 22.71,
    height: 1.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 191.36,
    className: "st16",
    width: 22.71,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 194.22,
    className: "st16",
    width: 22.71,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.86,
    y: 197.08,
    className: "st16",
    width: 22.71,
    height: 1.19
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.9671,
    y1: 1285.3785,
    x2: 384.4671,
    y2: 1264.3785,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1D1B",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363635",
      stopOpacity: 0.2
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M389.92,288.38c1.88-1.49,2.71-2.09,3.15-2.8c0.51,2.03,0.58,3.89,0.08,5.22s0.48,4.51,1.88,6.03 s1.01,5.82,1.35,6.61C394.65,299.37,389.92,288.38,389.92,288.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.1775,
    y1: 988.8493,
    x2: 274.1546,
    y2: 988.8493,
    gradientTransform: "matrix(1.2315 0.1382 -0.2156 1.2007 79.0261 -936.8603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#AD775A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#634723"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "195.65,293.16 192.34,287.42 199.66,282.22 203.39,288.69  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.6889,
    y1: 1277.4205,
    x2: 198.0223,
    y2: 1277.4205,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2D438F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C65A8"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M184.69,300.99c1.75-0.26,2.99-0.19,5.77-3.96c1.71-2.33,5.2-2.86,5.67-3.92c0.4-0.9-0.8-0.45-0.56-2.22 c0.18-1.32,1.33-1.63,1.79-2.15c1.32-1.49,0.46-3.49-0.75-4c-0.83-0.36-3.13-0.55-4.18,0.06c-1.05,0.61-2.86,6.64-2.97,6.89 C189.36,291.94,184.69,300.99,184.69,300.99z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M192.05,284.96c1.22-0.76,3.12,0.5,2.82,2.16c-0.3,1.65-1.38,3.39-3.09,4.96c-2.62,2.41-1.95,4.07-4.4,7.05 c-2.27,2.77-4.51,2.14-4.8,0.42c-0.3-1.72-0.26-5.41,3.01-8.7C187.87,288.56,190.04,286.21,192.05,284.96z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 983.2966,
    y1: 317.0975,
    x2: 985.0148,
    y2: 320.8575,
    gradientTransform: "matrix(0.6374 0.7705 -0.7705 0.6374 -162.9626 -661.9207)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#493EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#633AFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M220.51,298.29l-2.7,0.35l0.17,1.35C218.83,299.42,219.68,298.85,220.51,298.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.483,
    y1: 1236.8016,
    x2: 318.3093,
    y2: 1236.8016,
    gradientTransform: "matrix(0.9973 0.0732 -0.0732 0.9973 -2.2438 -953.8373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#AD775A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#634723"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M220.09,309.43l-4.2-7.41l1.92-6.09l3.09-0.12l4.22,1.03C224.21,299.14,221.36,306.56,220.09,309.43z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M203.89,240.85c-4.28-6.5-11.88-1.51-9.82,9.11c2.61,13.44,23.76,21.07,21.61,22.19 c-9.38,4.88-14.45,8.34-18.35,11.79c3.8,0.77,3.25,3.74,2.34,6.89c3.91-1.52,27.73-10.42,27.57-18.68 C227.1,264.81,212.93,254.58,203.89,240.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.5052,
    y1: 1189.6857,
    x2: 236.5231,
    y2: 1189.6857,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#AD775A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#634723"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M262.03,189.4c-0.48,1.82-3.97,3.51-5.17,5.3c0,0-0.4-0.66-0.05-1.25s1.27-1.61,0.99-2.53 c-0.27-0.32-3.11,2.66-3.38,3.34c-0.25,0.63,0.13,5.02-0.87,5.74c-4.65,8.23-12.01,13.19-15.76,15.19c0,0-10.75,8.83,2.08,5.33 s16.58-17.5,16.41-18.76l0,0c0.24-0.15,0.51-0.33,0.82-0.53c1.24-0.81,3.14-1.77,4.03-3.11c0.89-1.33,0.88-1.55,1.14-2.9 c0.24-1.25,0.04-2.48,0.62-4.46C263.36,189.15,262.51,187.58,262.03,189.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.0246,
    y1: 1256.2732,
    x2: 236.5406,
    y2: 1256.2732,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E2A783"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M200.26,239.24c-3.89,1.3-5.04,12.11,0.92,16.98c8.79,7.18,24.56,12.97,24.07,16.05 c-1.1,6.91-7.94,23.45-8.89,28.27c2.06-2.27,6.33,0.6,6.17,3.32c3.36-6.63,18.25-33.45,12.84-38.97 C228.26,257.63,210.94,240.11,200.26,239.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.5889,
    y1: 1297.329,
    x2: 221.9914,
    y2: 1297.329,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2D438F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C65A8"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M218.11,323.37c5.92-1.58,3.32-14.95,3.28-15.97c-0.04-1.03-0.24-2.14-1.05-1.1s-0.92,0.28-1.11-1.05 c-0.22-1.48-0.78-2.63-1.75-3.2s-1.92,0-3.89,2.07L218.11,323.37z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M218.09,306.62c-0.71-1.59-2.78-3.82-4.46-2.53c-1.11,0.86,0.08,4.65,0.29,5.72 c0.42,2.18-1.46,4.06-0.49,7.64c0.51,1.88,2.68,7.2,4.72,5.88c2.5-1.6,2.6-7.92,1.6-11.15 C218.75,308.95,218.68,307.95,218.09,306.62z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.9909,
    y1: 1209.583,
    x2: 242.3012,
    y2: 1209.583,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2D438F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C65A8"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M239.69,212.79c-4.36,1.7-9.41,2.39-11.19,1.56c-3.57-5.12-6.8-10.75-6.63-14.44l-1.03,8.1 c-5.33-2.63-11.48,0.58-11.48,0.58c-5.43,9.72-2.94,9.12-7.75,21.81c-1.93,5.08-3.91,4.35-6.19,8.61 c-3.11,5.83,11.52,12.94,18.31,10.19c5.43-2.19,4.86-8.06,5.66-10.61c0.72-2.26,5.6-5.91,8.04-12.38 c3.86-0.76,8.54-2.62,13.58-4.82C243.7,220.15,241.66,211.78,239.69,212.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.0911,
    y1: 1559.9148,
    x2: 254.7469,
    y2: 1556.063,
    gradientTransform: "matrix(0.9469 -0.3215 0.3215 0.9469 -520.4727 -1191.8422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006528178,
    style: {
      stopColor: "#AD775A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9924,
    style: {
      stopColor: "#634723"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M232.84,198.8c0.65,1.88-0.81,6.75-1.69,7.96c-0.89,1.2-5.79-0.56-6.68-1.09c-0.55-0.46-2.19,0.55-2.1,0.57 c0.59,0.17-0.2-5.43-1.2-6.25c-1.03-0.85,3.61-2.45,4.5-2.99c0.7-0.42,5.12-4.68,5.39-4.83c0.01,0.02,0.84-0.15,1.32,0.79 C233.34,194.85,232.01,196.43,232.84,198.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.6413,
    y1: 1188.1621,
    x2: 233.7718,
    y2: 1188.1621,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1D1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#575756"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M233,194.97c-1.5,3.31-7.23,2.5-5.99,7.75c0.51,2.2,1.21,4.63,1.34,6.89c0.2,3.14-0.68,5.94-4.61,7.36 c-6.74,2.43-15.91,4.43-15.04-4.19c0.88-8.62-1.96-13.52,5.3-17.26c0.37-0.19,0.71-0.38,1.03-0.58c6.11-3.76,5.41-9.14,13.65-6.35 C234.19,190.45,234.5,191.66,233,194.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.6133,
    y1: 1205.1759,
    x2: 211.4467,
    y2: 1169.5927,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1D1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363635"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M223.74,216.97c-6.74,2.43-15.91,4.43-15.04-4.19c0.88-8.62-1.96-13.52,5.3-17.26 c0.37-0.19,0.71-0.38,1.03-0.58c0,0.21-0.04,0.45-0.14,0.72c-0.51,1.39-1.09,2.58-1.43,4.05c-0.49,2.13-0.99,4.27-1.49,6.4 c-0.24,1.07-0.49,2.16-0.44,3.26c0.06,1.1,0.46,2.22,1.31,2.92c1.15,0.93,2.79,0.88,4.27,0.77c3.27-0.23,6.73-0.52,9.4-2.42 c0.57-0.41,1.18-0.91,1.84-1.03C228.55,212.75,227.67,215.55,223.74,216.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.7088,
    y1: 1217.8481,
    x2: 227.4489,
    y2: 1217.8481,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1D1B",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363635",
      stopOpacity: 0.2
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M227.45,226.22c-2.41,0.26-2.89-0.2-4.01-1.36c0.42,5.04-5.86,9.61-4.55,16.53c0.69-3.75,1.54-4.67,2.32-5.5 C222,235.07,227.27,228.75,227.45,226.22z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M303.52,165.05c0-0.76,0.62-1.38,1.38-1.38s1.38,0.62,1.38,1.38c0,0.76-0.62,1.38-1.38,1.38 S303.52,165.81,303.52,165.05z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M322.55,159.3c0.6,0.47,0.7,1.34,0.23,1.94s-1.34,0.7-1.94,0.23s-0.7-1.34-0.23-1.94 C321.08,158.93,321.95,158.82,322.55,159.3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M302.47,202.41c-3.17,0-5.75-2.58-5.75-5.75s2.58-5.75,5.75-5.75s5.75,2.58,5.75,5.75 S305.64,202.41,302.47,202.41z M302.47,192.09c-2.52,0-4.56,2.05-4.56,4.56c0,2.52,2.05,4.56,4.56,4.56s4.56-2.05,4.56-4.56 C307.03,194.14,304.98,192.09,302.47,192.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M302.47,203c-3.5,0-6.35-2.85-6.35-6.35s2.85-6.35,6.35-6.35v2.38c-2.19,0-3.97,1.78-3.97,3.97 s1.78,3.97,3.97,3.97s3.97-1.78,3.97-3.97h2.38C308.82,200.16,305.97,203,302.47,203z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M321.52,202.41c-3.17,0-5.75-2.58-5.75-5.75s2.58-5.75,5.75-5.75s5.75,2.58,5.75,5.75 S324.69,202.41,321.52,202.41z M321.52,192.09c-2.52,0-4.56,2.05-4.56,4.56c0,2.52,2.05,4.56,4.56,4.56 c2.52,0,4.56-2.05,4.56-4.56C326.08,194.14,324.03,192.09,321.52,192.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M321.52,203v-2.38c2.19,0,3.97-1.78,3.97-3.97s-1.78-3.97-3.97-3.97v-2.38c3.5,0,6.35,2.85,6.35,6.35 C327.87,200.16,325.02,203,321.52,203z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.9189,
    y1: 1152.8531,
    x2: 415.5589,
    y2: 1152.8531,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st53",
    cx: 402.74,
    cy: 168.13,
    r: 12.82
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M408.35,166.91L408.35,166.91c-0.73-0.7-1.56-1.26-2.49-1.66c-1.98-0.84-4.25-0.84-6.24,0 c-0.93,0.4-1.76,0.95-2.49,1.66c-0.33,0.32-0.51,0.76-0.51,1.23c0,0.46,0.19,0.91,0.52,1.23c1.51,1.46,3.5,2.27,5.61,2.27 s4.1-0.81,5.61-2.27c0.33-0.32,0.52-0.77,0.52-1.23C408.87,167.66,408.68,167.23,408.35,166.91z M407.54,168.52 c-1.29,1.25-2.99,1.94-4.8,1.94s-3.5-0.69-4.8-1.94c-0.1-0.1-0.16-0.24-0.16-0.39s0.06-0.29,0.16-0.39c0.58-0.56,1.25-1,1.97-1.33 c0.27,1.31,1.44,2.3,2.83,2.3c1.4,0,2.56-0.99,2.83-2.3c0.73,0.33,1.39,0.77,1.97,1.33c0.1,0.1,0.16,0.24,0.16,0.39 S407.64,168.42,407.54,168.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.4889,
    y1: 1249.1932,
    x2: 378.3412,
    y2: 1249.1932,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1D1B",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363635",
      stopOpacity: 0.2
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M371.49,260.21c1.25-1.03,3.69-3.16,5.06-5.66c-0.44,5.19,2.75,6.83,1.5,11.51 c-1.25,4.68-1.89,5.83-1.19,8.33c-1.94-7.47-2.06-8.16-2.69-9.22S371.49,260.21,371.49,260.21z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 300.5246 262.6434)",
    className: "st16 st55 st56"
  }, "RPA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 299.5182 265.7191)",
    className: "st16 st55 st57"
  }, "automation data"))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_49_",
    cx: -765.5381,
    cy: -434.0743,
    r: 5.8734,
    gradientTransform: "matrix(-2.4922 0 0 -2.6292 -1650.4651 -831.1296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6A391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st58",
    cx: 257.41,
    cy: 310.14,
    rx: 14.64,
    ry: 15.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.5889,
    y1: 1290.8231,
    x2: 270.2289,
    y2: 1290.8231,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st59",
    cx: 257.41,
    cy: 306.1,
    r: 12.82
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M262.68,303.67h-10.52c-0.49,0-0.89-0.4-0.89-0.89v-0.95c0-0.49,0.4-0.89,0.89-0.89h10.52 c0.49,0,0.89,0.4,0.89,0.89v0.95C263.57,303.27,263.17,303.67,262.68,303.67z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M262.68,307.14h-10.52c-0.49,0-0.89-0.4-0.89-0.89v-0.95c0-0.49,0.4-0.89,0.89-0.89h10.52 c0.49,0,0.89,0.4,0.89,0.89v0.95C263.57,306.74,263.17,307.14,262.68,307.14z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M262.68,310.61h-10.52c-0.49,0-0.89-0.4-0.89-0.89v-0.95c0-0.49,0.4-0.89,0.89-0.89h10.52 c0.49,0,0.89,0.4,0.89,0.89v0.95C263.57,310.21,263.17,310.61,262.68,310.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.9189,
    y1: 1287.0332,
    x2: 260.6895,
    y2: 1287.0332,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st60",
    cx: 259.81,
    cy: 302.31,
    r: 0.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.2888,
    y1: 1287.0332,
    x2: 263.0594,
    y2: 1287.0332,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st61",
    cx: 262.18,
    cy: 302.31,
    r: 0.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.9189,
    y1: 1290.5032,
    x2: 260.6895,
    y2: 1290.5032,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st62",
    cx: 259.81,
    cy: 305.78,
    r: 0.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.2888,
    y1: 1290.5032,
    x2: 263.0594,
    y2: 1290.5032,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st63",
    cx: 262.18,
    cy: 305.78,
    r: 0.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.2888,
    y1: 1293.9731,
    x2: 263.0594,
    y2: 1293.9731,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st64",
    cx: 262.18,
    cy: 309.25,
    r: 0.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.9189,
    y1: 1293.9731,
    x2: 260.6895,
    y2: 1293.9731,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st65",
    cx: 259.81,
    cy: 309.25,
    r: 0.89
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_57_",
    cx: -734.1152,
    cy: -576.9653,
    r: 5.8667,
    gradientTransform: "matrix(-2.3634 0 0 -1.757 -1550.3188 -844.0695)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6A391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st66",
    cx: 184.69,
    cy: 169.66,
    rx: 13.88,
    ry: 10.32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.8089,
    y1: 1148.8481,
    x2: 198.5789,
    y2: 1148.8481,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M180.11,153.89h-7.79c-0.83,0-1.51,0.76-1.51,1.7v17.07c0,0.94,0.68,1.7,1.51,1.7h24.75 c0.83,0,1.51-0.76,1.51-1.7v-13.82c0-0.94-0.68-1.7-1.52-1.7l-13.15,0.08c-0.47,0-0.91-0.24-1.2-0.65l-1.41-2.03 C181.01,154.13,180.57,153.89,180.11,153.89z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M190.62,167.31h-11.86c-0.94,0-1.69-0.76-1.69-1.69v-0.42c0-0.94,0.76-1.69,1.69-1.69h11.86 c0.94,0,1.69,0.76,1.69,1.69v0.42C192.31,166.55,191.56,167.31,190.62,167.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.4136,
    y1: 1150.1332,
    x2: 180.4448,
    y2: 1150.1332,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st68",
    cx: 179.43,
    cy: 165.41,
    rx: 1.02,
    ry: 1.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.0449,
    y1: 1150.1332,
    x2: 191.0761,
    y2: 1150.1332,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st69",
    cx: 190.06,
    cy: 165.41,
    rx: 1.02,
    ry: 1.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.9727,
    y1: 1150.1332,
    x2: 184.0039,
    y2: 1150.1332,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    cx: 182.99,
    cy: 165.41,
    rx: 1.02,
    ry: 1.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.5318,
    y1: 1150.1332,
    x2: 187.563,
    y2: 1150.1332,
    gradientTransform: "matrix(1 0 0 1 0 -984.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3D3C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#87ABB7"
    }
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st71",
    cx: 186.55,
    cy: 165.41,
    rx: 1.02,
    ry: 1.14
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_63_",
    cx: -810.6308,
    cy: -460.5957,
    r: 5.8734,
    gradientTransform: "matrix(-2.4922 0 0 -2.6292 -1650.4651 -831.1296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6A391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st72",
    cx: 369.79,
    cy: 379.87,
    rx: 14.64,
    ry: 15.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.257,
    y1: 1469.1023,
    x2: 154.9023,
    y2: 1469.1023,
    gradientTransform: "matrix(0.9854 -0.17 0.17 0.9854 -19.4338 -1047.8313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 370.32,
    cy: 375.67,
    r: 12.82
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M366.56,376.51c0-0.6,0-1.21,0-1.81c0-0.66,0.31-1.13,0.89-1.43c0.1-0.05,0.13-0.1,0.13-0.21 c0.02-1.15,0.35-2.2,1.13-3.08c0.55-0.62,1.23-0.99,2.08-0.98c0.84,0.01,1.51,0.4,2.06,1.02c0.59,0.68,0.91,1.48,1.03,2.36 c0.03,0.24,0.05,0.48,0.06,0.72c0,0.08,0.03,0.11,0.1,0.15c0.6,0.29,0.92,0.77,0.93,1.44c0.01,1.22,0.01,2.44,0,3.65 c0,0.73-0.34,1.3-0.87,1.78c-0.69,0.62-1.53,0.95-2.44,1.08c-1.03,0.16-2.04,0.06-3.01-0.33c-0.7-0.28-1.3-0.7-1.72-1.34 c-0.24-0.37-0.36-0.77-0.36-1.21C366.56,377.72,366.56,377.11,366.56,376.51z M372.62,373.11c-0.03-0.74-0.16-1.44-0.64-2.02 c-0.71-0.86-1.87-0.82-2.53,0.08c-0.26,0.36-0.42,0.76-0.49,1.19c-0.04,0.25-0.06,0.49-0.1,0.75 C370.13,373.11,371.36,373.11,372.62,373.11z M371.4,378.66c0-0.33,0-0.63,0-0.94c0-0.1,0.02-0.16,0.1-0.23 c0.33-0.27,0.48-0.62,0.44-1.04c-0.05-0.52-0.46-0.97-0.96-1.05c-0.57-0.09-1.1,0.19-1.32,0.7c-0.21,0.5-0.06,1.07,0.36,1.41 c0.05,0.04,0.08,0.11,0.08,0.17c0.01,0.29,0,0.57,0,0.86c0,0.07,0,0.12,0.09,0.12C370.59,378.66,370.98,378.66,371.4,378.66z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_65_",
    cx: -765.5381,
    cy: -461.4324,
    r: 5.8734,
    gradientTransform: "matrix(-2.4922 0 0 -2.6292 -1650.4651 -831.1296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6A391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st74",
    cx: 257.41,
    cy: 382.07,
    rx: 14.64,
    ry: 15.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.1359,
    y1: 1452.1543,
    x2: 43.7812,
    y2: 1452.1543,
    gradientTransform: "matrix(0.9854 -0.17 0.17 0.9854 -19.4338 -1047.8313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st75",
    cx: 257.94,
    cy: 377.86,
    r: 12.82
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st76",
    cx: 253.02,
    cy: 372.37,
    r: 1.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 258.71,
    cy: 372.37,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 255.54,
    cy: 377.38,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 260.49,
    cy: 377.38,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st77",
    cx: 257.39,
    cy: 382.42,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st76",
    cx: 263.1,
    cy: 382.42,
    r: 1.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st78",
    cx: 263.1,
    cy: 382.42,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 263.1,
    cy: 382.42,
    r: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st76",
    x1: 254.88,
    y1: 372.37,
    x2: 257.73,
    y2: 372.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M259.68,372.37c0,0,2.38,0.02,3.65,0.08c1.44,0.07,2.05,2.89,0.74,4.25c-0.46,0.47-1.32,0.67-2.61,0.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st76",
    x1: 256.51,
    y1: 377.38,
    x2: 259.39,
    y2: 377.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st76",
    x1: 258.37,
    y1: 382.42,
    x2: 261.16,
    y2: 382.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M256.42,382.42c0,0-2.38-0.02-3.65-0.08c-1.44-0.07-2.05-2.92-0.74-4.28c0.46-0.48,1.32-0.67,2.61-0.67"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_67_",
    cx: -836.2588,
    cy: -404.3961,
    r: 5.8734,
    gradientTransform: "matrix(-2.4922 0 0 -2.6292 -1650.4651 -831.1296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6A391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st79",
    cx: 433.66,
    cy: 232.11,
    rx: 14.64,
    ry: 15.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.3231,
    y1: 1334.3359,
    x2: 242.9684,
    y2: 1334.3359,
    gradientTransform: "matrix(0.9854 -0.17 0.17 0.9854 -19.4338 -1047.8313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2A78A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9A697"
    }
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st80",
    cx: 434.19,
    cy: 227.9,
    r: 12.82
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M434.24,235.41c-0.57-0.03-1.16,0.09-1.54-0.93c-0.03-0.29,0.01-0.57-0.03-0.86 c-0.45-0.17-0.9-0.36-1.34-0.56c-0.49,0.35-0.69,1.03-1.85,0.65c-0.29-0.26-0.57-0.53-0.84-0.82c-0.37-0.39-0.42-1-0.11-1.44 c0.16-0.23,0.42-0.41,0.56-0.65c-0.21-0.43-0.39-0.87-0.55-1.32c-0.62-0.12-1.39,0.24-1.76-1.04c-0.01-0.04-0.02-0.08-0.02-0.12 c0-0.5,0-1,0-1.5c0.43-0.31,0.84-0.54,1.3-0.49l1.07-0.79c0.15-0.64-0.3-0.82-0.56-1.15c-0.33-0.43-0.33-1.02,0.02-1.43 c0.23-0.27,0.48-0.52,0.75-0.75c0.46-0.38,1.12-0.33,1.56,0.1c0.24,0.24,0.46,0.5,0.8,0.63c1.28-0.36,0.93-1.04,1.03-1.63 c0.1-0.58,0.69-1,1.28-0.91c0.18,0.03,0.36,0.02,0.54,0c0.65-0.08,1.24,0.44,1.27,1.07c0.01,0.23-0.01,0.46,0.05,0.69 c0.44,0.19,0.87,0.37,1.31,0.55c0.25-0.14,0.42-0.41,0.67-0.57c0.48-0.3,1.04-0.23,1.45,0.17c0.34,0.33,0.68,0.67,1,1.01 c0.1,0.92-0.51,1.16-0.87,1.64c0.19,0.45,0.37,0.9,0.56,1.34c0.61,0.13,1.29-0.27,1.73,1.03c0.02,0.05,0.02,0.1,0.03,0.14 c0.01,0.47,0,0.94-0.01,1.4c-0.56,0.76-1.16,0.52-1.75,0.6c-0.18,0.45-0.36,0.89-0.56,1.33c0.15,0.24,0.4,0.42,0.56,0.66 c0.3,0.44,0.25,1.03-0.12,1.42c-0.25,0.27-0.52,0.54-0.8,0.79c-0.01,0.01-0.02,0.01-0.03,0.02c-1.23,0.43-1.36-0.3-1.89-0.62 c-0.43,0.19-0.87,0.38-1.32,0.54c-0.07,0.28-0.01,0.59-0.07,0.88c-0.1,0.51-0.56,0.89-1.08,0.9c-0.15,0-0.3,0-0.46,0 C434.24,235.4,434.24,235.4,434.24,235.41z M434.25,221.13c-0.25,0-0.51-0.01-0.76,0.03c-0.09,0.25-0.04,0.51-0.06,0.77 c-0.03,0.48-0.27,0.82-0.71,1.01c-0.3,0.13-0.6,0.25-0.9,0.38c-0.02,0.01-0.04,0.01-0.05,0.02c-0.46,0.14-0.86,0.04-1.21-0.29 c-0.18-0.17-0.33-0.37-0.59-0.43c-0.36,0.34-0.71,0.68-1.04,1.05c0.3,0.46,0.82,0.7,0.97,1.31c-0.22,0.45-0.39,0.91-0.59,1.37 c-0.18,0.41-0.48,0.65-0.93,0.71c-0.29,0.04-0.6-0.03-0.88,0.09c-0.02,0.49-0.02,0.99,0,1.49c0.56,0.19,1.14-0.17,1.69,0.5 c0.13,0.39,0.3,0.76,0.45,1.13c0.19,0.46,0.13,0.89-0.2,1.26c-0.17,0.2-0.41,0.36-0.49,0.64c0.34,0.34,0.68,0.69,1.03,1.03 c0.26-0.1,0.41-0.31,0.59-0.48c0.38-0.35,0.81-0.42,1.28-0.23c0.28,0.11,0.56,0.23,0.84,0.35c0.41,0.17,0.65,0.48,0.71,0.92 c0.04,0.29-0.03,0.59,0.08,0.87c0.51,0.03,1.02,0.04,1.52,0c0.12-0.54-0.11-1.09,0.32-1.63c0.43-0.15,0.86-0.34,1.28-0.51 c0.39-0.16,0.77-0.14,1.11,0.09c0.27,0.18,0.46,0.49,0.76,0.62c0.36-0.35,0.72-0.71,1.07-1.07c-0.29-0.49-0.86-0.71-0.94-1.4 c0.21-0.41,0.38-0.85,0.55-1.27c0.16-0.39,0.44-0.64,0.86-0.72c0.32-0.06,0.67,0.02,0.96-0.11c0.01-0.5,0.01-1,0-1.5 c-0.55-0.14-1.1,0.12-1.64-0.35c-0.2-0.52-0.39-1.05-0.66-1.55c-0.09-0.88,0.59-1.03,0.86-1.58c-0.35-0.37-0.71-0.73-1.08-1.08 c-0.48,0.31-0.71,0.87-1.42,0.95c-0.4-0.23-0.83-0.39-1.26-0.57c-0.4-0.17-0.65-0.47-0.72-0.9c-0.05-0.3,0.04-0.62-0.1-0.9 C434.74,221.12,434.5,221.13,434.25,221.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M436.93,224.8c3.59,4.11-1.17,9.11-5.31,6.11C428.06,227.16,432.4,221.85,436.93,224.8z M431.06,227.94 c0.04,1.8,1.53,3.19,3.28,3.13c2.65-0.08,4.39-3.33,1.91-5.84C433.43,223.69,430.99,225.7,431.06,227.94z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dcfd07d2342bbd0a025298164dcb3bde.svg";
export { ForwardRef as ReactComponent };